var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergencyElectricity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 74,
    viewBox: "0 0 95 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M7.545 63C2.771 55.536 0 46.643 0 37.096 0 22.127 6.812 8.766 17.477 0h59.717A47.86 47.86 0 0184 6.857L7.545 63z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M7.682 62.28L83.279 6.766A47.356 47.356 0 0077.015.5H17.657C6.876 9.43.5 22.734.5 37.096.5 46.137 3.016 54.8 7.682 62.28z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M88.19 12C92.513 19.18 95 27.593 95 36.587 95 51.749 87.693 65.259 76.675 74H17.693A47.995 47.995 0 0111 67.54L88.19 12z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M88.04 12.725L11.734 67.626a47.496 47.496 0 006.132 5.874H76.5c11.241-8.983 18-22.468 18-36.913 0-8.51-2.253-16.688-6.46-23.862z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M55.985 65h-15.97a8.123 8.123 0 01-.015-.5V58a8 8 0 1116 0v6.5c0 .168-.005.335-.015.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M55.5 64.5V58a7.5 7.5 0 00-15 0v6.5h15z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M26 12h8v29h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M26.5 12.5h7v28h-7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M69 25.865V39h-8v-7.574l8-5.561zm-8-2.393V14h8v4.157l-8 5.315z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M68.5 26.821l-7 4.866V38.5h7V26.821zm-7-4.281l7-4.651V14.5h-7v8.04z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyElectricity);
export default __webpack_public_path__ + "static/media/EmergencyElectricity.5222d62fd611415b31c190b0c09e1043.svg";
export { ForwardRef as ReactComponent };